import React, { useEffect, useState } from "react";
import { useNavigate,Link } from 'react-router-dom';
import FetchFunc from "./API";
import "./components.css";
import fill from './asset/Pin_alt_fill.png';
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";

// search button
const Colorbutton1 = () => {
    return (
        <div className="select_button">
            <button
                style={{
                    backgroundColor: '#008286',
                    color: 'white',
                    borderRadius: '0.9rem 0.9rem 0px 0px',
                    width: '14rem',
                    height: '2.56rem',
                    border: 'none',
                    fontSize: '0.875rem',
                    fontFamily: 'Montserrat',
                }}
            >
                Building & Pest inspection
            </button>
        </div>
    );
};

export default Colorbutton1;

const preprocessAddress = (address) => {
    // Ensure a space after commas
    return address.replace(/,([^\s])/g, ', $1').trim();
};

const addressRegex = /^([\d/-]+[A-Za-z]?)[ ]+([A-Za-z0-9 '\u2018\u2019.&/()-]+?),[ ]*([A-Za-z0-9 '\u2018\u2019.&/()-]+)[ ]+(NSW|VIC|QLD|WA|SA|TAS|NT|ACT)[ ]+(\d{4})(?:,[ ]*([A-Za-z0-9 '\u2018\u2019.&/()-]+))?$/i;

// search box
const parseAddress = (address, shouldLog = true) => {
    const normalizedAddress = preprocessAddress(address);
    // console.log("Normalized Address:", normalizedAddress);
    // const addressRegex = /^(\d+[A-Za-z]?)\s+(.+?),\s*(.+?)\s+(NSW|VIC|QLD|WA|SA|TAS|NT|ACT)\s+(\d{4})(?:,\s*(.+))$/i;
    // const match = normalizedAddress.match(addressRegex);

    const match = normalizedAddress.match(addressRegex);

    if (!match) {
        if (shouldLog) {
        console.error("Invalid address format: " + address);
        }
        return null;
    }

    const [, streetNumber, streetName, suburb, state, postcode] = match;
    
    return {
        address,
        streetName,
        streetNumber,
        suburb,
        state,
        postcode,
    };
};

const getAddressComponent = (place, type, name = 'long_name') => {
    const component = (place.address_components || []).find((item) => item.types.includes(type));
    return component ? component[name] : '';
};

const parsePlaceAddress = (place) => {
    const formattedAddress = place.formatted_address || '';
    const parsedFormattedAddress = parseAddress(formattedAddress, false);
    if (parsedFormattedAddress) {
        return parsedFormattedAddress;
    }

    const subpremise = getAddressComponent(place, 'subpremise');
    const streetNumber = [subpremise, getAddressComponent(place, 'street_number')].filter(Boolean).join('/');
    const streetName = getAddressComponent(place, 'route', 'short_name') || getAddressComponent(place, 'route');
    const suburb = getAddressComponent(place, 'locality')
        || getAddressComponent(place, 'postal_town')
        || getAddressComponent(place, 'sublocality')
        || getAddressComponent(place, 'administrative_area_level_2');
    const state = getAddressComponent(place, 'administrative_area_level_1', 'short_name');
    const postcode = getAddressComponent(place, 'postal_code');
    const address = formattedAddress || [streetNumber, streetName, suburb, state, postcode].filter(Boolean).join(' ');

    return {
        address,
        streetName,
        streetNumber,
        suburb,
        state,
        postcode,
    };
};

const libraries = ['places'];

const SearchBox = () => {
    const [formData, setFormData] = useState({
        propertyId: '',
        placeId: '',
        address:'',
        type: '',
        streetNumber: '',
        streetName: '',
        suburb: '',
        state: '',
        roomNumber: 2,
        postcode: ''
    });

    const [query, setQuery] = useState('');
    const [autocomplete, setAutocomplete] = useState(null);
    const navigate = useNavigate();
    // const [bounds, setBounds] = useState(null);

    // useEffect(() => {
    //     if (!window.google || !window.google.maps) {
    //         console.error("Google Maps API is not loaded.");
    //         return;
    //     }
    //     // navigator.geolocation.getCurrentPosition(
    //     //     (position) => {
    //     //         const { latitude, longitude } = position.coords;
    //     //         const userLocation = new window.google.maps.LatLng(latitude, longitude);
    //     //         const radius = 1000000;
    //     //         const circle = new window.google.maps.Circle({
    //     //             center: userLocation,
    //     //             radius: radius,
    //     //         });
    //     //         setBounds(circle.getBounds());
    //     //     },
    //     //     () => {
    //     //         console.error("Fail to get user location")
    //     //     }
    //     // );
    // }, []);

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            address: query,
        }));
    }, [query]);

    const onLoad = (autocompleteInstance) => {
        setAutocomplete(autocompleteInstance);
    };

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: libraries,
    });
    
    if (!isLoaded) {
        return <div>Loading...</div>;
    }


    const handleSearchDirect = async (address, placeId, parsedAddress = null) => {
        console.log('Selected Place:', address, 'PlaceId:', placeId);
        const addressFields = parsedAddress || parseAddress(address);
        if (!placeId && !addressFields) {
            alert('Invalid Address');
            return;
        }
    
        const dataToSend = {
            ...formData,
            ...(addressFields || { address }),
            placeId,
        };
    
        try {
            const response = await FetchFunc(
                '/search/',
                'POST',
                JSON.stringify(dataToSend)
            );
            if (response.status === 200) {
                const data = await response.json();
                localStorage.setItem('price', data.reportPrice);
                navigate(`/report/${data.propertyId}`, { state: { query: address } });
            } else if (response.status === 404) {
                navigate(`/bookinspector`, { state: { query: address } });
            } else if (response.status === 401) {
                navigate('/login');
            } else {
                navigate(`/bookinspector`, { state: { query: address } });
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            
        }
    };
    
    const onPlaceChanged = () => {
    if (autocomplete !== null) {
        console.log('autocomplete');
        const place = autocomplete.getPlace();
        const parsedAddress = parsePlaceAddress(place);
        const formattedAddress = parsedAddress.address;
        const placeId = place.place_id || '';

        if (!formattedAddress || !placeId) {
            alert('Invalid Address');
            return;
        }

        setQuery(formattedAddress);
        setFormData((prevData) => ({
            ...prevData,
            ...parsedAddress,
            address: formattedAddress,
            placeId: placeId,
        }));

        handleSearchDirect(formattedAddress, placeId, parsedAddress); // pass both address and placeId
    }
};


    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        setQuery(inputValue);
        setFormData((prevData) => ({
            ...prevData,
            address: inputValue,
            placeId: '',
        }));
        
    };

    // const handleSearch = async (e) => {
    //     e.preventDefault();
    //     const dataToSend = {
    //         ...formData,
    //         ...parseAddress(query),
    //     };
    //     // console.log(dataToSend);
    //     if (!addressRegex.test(query)){
    //         alert('Invalid Address');
    //     } else {
    //         try {
    //             // console.log('Data send:', dataToSend);
    //             const response = await FetchFunc(
    //                 '/search/',
    //                 'POST',
    //                 JSON.stringify(dataToSend)
    //             );
    //             if (response.status === 200) {
    //                 // console.log('Response from server:', response);
    //                 const data = await response.json();
    //                 localStorage.setItem('price', data.reportPrice);
    //                 // console.log(data);
    //                 navigate(`/report/${data.propertyId}`, { state: { query }});
    //             } else if (response.status === 404) {
    //                 navigate(`/bookinspector`, { state: { query }});
    //             } else if (response.status === 401) {
    //                 navigate('/login');
    //             } else {
    //                 navigate(`/bookinspector`, { state: { query }});
    //                 // console.log(response.text());
    //                 throw new Error(`HTTP error! Status: ${response.status}`);
    //             }
    //         } catch (error) {
    //             console.error('Failed to submit address:', error);
    //         }
    //     }
    // };

    return (
        <div className="search_box">
            <Autocomplete 
                onLoad={onLoad} 
                onPlaceChanged={onPlaceChanged}
                // bounds={bounds}
                options={{
                    strictBounds: true,
                    types: ['address'],
                    componentRestrictions: { country: "AU" },
                }}
            >
                <input className="screen_search"
                    type="text"
                    value={query}
                    placeholder=''
                    onChange={handleInputChange}
                />
            </Autocomplete>            
            {/* <button className="screen_search_button"
                // onClick={handleSearch}
            >
                SEARCH         
            </button>             */}
        </div>
    );
};

export { SearchBox };

const MobileSearchBox = () => {
    const [formData, setFormData] = useState({
        propertyId: '',
        placeId: '',
        address:'',
        type: '',
        streetNumber: '',
        streetName: '',
        suburb: '',
        state: '',
        roomNumber: 2,
        postcode: ''
    });

    const [query, setQuery] = useState('');
    const [autocomplete, setAutocomplete] = useState(null);
    const navigate = useNavigate();
    const libraries = ['places'];
    // const [bounds, setBounds] = useState(null);

    // useEffect(() => {
    //     if (!window.google || !window.google.maps) {
    //         console.error("Google Maps API is not loaded.");
    //         return;
    //     }
    //     // navigator.geolocation.getCurrentPosition(
    //     //     (position) => {
    //     //         const { latitude, longitude } = position.coords;
    //     //         const userLocation = new window.google.maps.LatLng(latitude, longitude);
    //     //         const radius = 1000000;
    //     //         const circle = new window.google.maps.Circle({
    //     //             center: userLocation,
    //     //             radius: radius,
    //     //         });
    //     //         setBounds(circle.getBounds());
    //     //     },
    //     //     () => {
    //     //         console.error("Fail to get user location")
    //     //     }
    //     // );
    // }, []);

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            address: query,
        }));
    }, [query]);

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: libraries,
    });

    const onLoad = (autocompleteInstance) => {
        setAutocomplete(autocompleteInstance);
    };

    const handleSearchDirect = async (address, placeId, parsedAddress = null) => {
        console.log('Selected Place:', address, 'PlaceId:', placeId);
        const addressFields = parsedAddress || parseAddress(address);
        if (!placeId && !addressFields) {
            alert('Invalid Address');
            return;
        }
    
        const dataToSend = {
            ...formData,
            ...(addressFields || { address }),
            placeId,
        };
    
        try {
            const response = await FetchFunc(
                '/search/',
                'POST',
                JSON.stringify(dataToSend)
            );
            if (response.status === 200) {
                const data = await response.json();
                localStorage.setItem('price', data.reportPrice);
                navigate(`/report/${data.propertyId}`, { state: { query: address } });
            } else if (response.status === 404) {
                navigate(`/bookinspector`, { state: { query: address } });
            } else if (response.status === 401) {
                navigate('/login');
            } else {
                navigate(`/bookinspector`, { state: { query: address } });
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        } catch (error) {
            
        }
    };

    const onPlaceChanged = () => {
        if (autocomplete !== null) {
            console.log('autocomplete');
            const place = autocomplete.getPlace();
            const parsedAddress = parsePlaceAddress(place);
            const formattedAddress = parsedAddress.address;
            const placeId = place.place_id || '';

            if (!formattedAddress || !placeId) {
                alert('Invalid Address');
                return;
            }

            setQuery(formattedAddress);
            setFormData((prevData) => ({
                ...prevData,
                ...parsedAddress,
                address: formattedAddress,
                placeId: placeId,
            }));

            handleSearchDirect(formattedAddress, placeId, parsedAddress); // pass both address and placeId
        }
    };

    if (!isLoaded) {
        return <div>Loading...</div>;
    }
    
    const handleInputChange = (e) => {
        const inputValue = e.target.value;
        setQuery(inputValue);
        setFormData((prevData) => ({
            ...prevData,
            address: inputValue,
            placeId: '',
        }));
        
    };

    // const handleSearch = async (e) => {
    //     e.preventDefault();
    //     const dataToSend = {
    //         ...formData,
    //         ...parseAddress(query),
    //     };
    //     // console.log(dataToSend);
    //     if (!addressRegex.test(query)){
    //         alert('Invalid Address');
    //     } else {
    //         try {
    //             // console.log('Data send:', dataToSend);
    //             const response = await FetchFunc(
    //                 '/search/',
    //                 'POST',
    //                 JSON.stringify(dataToSend)
    //             );
    //             if (response.status === 200) {
    //                 // console.log('Response from server:', response);
    //                 const data = await response.json();
    //                 localStorage.setItem('price', data.reportPrice);
    //                 // console.log(data);
    //                 navigate(`/report/${data.propertyId}`, { state: { query }});
    //             } else if (response.status === 404) {
    //                 navigate(`/bookinspector`, { state: { query }});
    //             } else if (response.status === 401) {
    //                 navigate('/login');
    //             } else {
    //                 navigate(`/bookinspector`, { state: { query }});
    //                 // console.log(response.text());
    //                 throw new Error(`HTTP error! Status: ${response.status}`);
    //             }
    //         } catch (error) {
    //             console.error('Failed to submit address:', error);
    //         }
    //     }
    // };

    return (
        <div>
            <div className='mobile_search_box'>
                <div className="mobile_select_button">
                    <button
                        style={{
                            backgroundColor: '#008286',
                            color: 'white',
                            borderRadius: '0.9rem',
                            width: '14rem',
                            height: '2.56rem',
                            border: 'none',
                            fontSize: '0.875rem',
                            fontFamily: 'Montserrat',
                        }}
                    >
                        Building & Pest inspection
                    </button>
                </div>
                <div className='mobile_type_area'>
                    <img src={fill} alt='fill' />
                    <Autocomplete 
                        onLoad={onLoad} 
                        onPlaceChanged={onPlaceChanged}
                        // bounds={bounds}
                        options={{
                            strictBounds: true,
                            types: ['address'],
                            componentRestrictions: { country: "AU" },
                        }}
                    >
                        <input className="mobile_search"
                            type="text"
                            value={query}
                            onChange={handleInputChange}
                            placeholder=''
                        />
                    </Autocomplete>
                </div>
                <p>Can't find property? <Link to='/address' className='find_address'>Click here</Link></p>
            </div>
            {/* <button className="mobile_search_button"
                onClick={handleSearch}
            >
                SEARCH         
            </button> */}
        </div>
    );
};

export { MobileSearchBox };
